export default {
  getQuoteTemplate: (state) => state.quoteTemplate,
  clientTemplates: (state) => state.quoteTemplates.filter((qt) => qt.quoteTemplateType === 'Client Template'),
  agreementTemplates: (state) => state.quoteTemplates.filter((qt) => qt.quoteTemplateType === 'Agreement Template'),
};
